export enum DetailType {
  argument = 0,
}
